<template>
  <!-- 通话中不予关闭 -->
  <Modal
    :closable="statusCode == null || ['idle', 'offline'].indexOf(this.statusCode) >=0 "
    :styles="{top: '50px', width: 'max-content', maxWidth: '90vw'}"
    :title="`${type =='followUp'?'回访':(type=='callback'?'回拨':'话务')}工作台`"
    @on-cancel="cancelPanel"
    class-name="hlModal noPaddingModal"
    footer-hide
    v-model="showPanel"
  >
    <div :class="'workbenchContainer '">
      <div class="leftWork">
        <component
          :is="allPanelComps[opts.serviceCode]"
          :options="opts"
          @changePanel="changePanel"
          @changeRecordStatus="changeRecordStatus"
          @changeStatus="changeStatus"
          @hangUpRecord="hangUpRecord"
          @loadCallRecord="loadCallRecord"
          @onCallComing="onCallComing"
          @onCallRelease="onCallRelease"
          @onRegister="onRegister"
          @pushCallRecord="pushCallRecord"
          @signLog="signLog"
          @updateCallRecord="updateCallRecord"
          @updateSoundRecording="updateSoundRecording"
          ref="workbenchToolContainer"
        ></component>
        <!-- <div class="workbenchTool mb1" id="workbenchTool"></div> -->
      </div>
      <div class="rightInfo">
        <div class="followUpContainer" v-if="type =='followUp'">
          <followUpGaugingResult :itemId="callPhoneData.followUpItemId" />itemId
        </div>
        <div class="callbackContainer" v-if="type =='callback'">
          <callbackResult :itemId="callPhoneData.itemId" v-if="callPhoneData.itemId" />
          <HLDetail
            :currentId="currentLedgerId"
            :edit="true"
            @cancelLedger="cancelLedger"
            ref="workbenchDetail"
          >
            <template slot="extLeft"></template>
          </HLDetail>
        </div>
        <template v-else>
          <HLDetail
            :currentId="currentLedgerId"
            :edit="true"
            @cancelLedger="cancelLedger"
            ref="workbenchDetail"
          >
            <template slot="extLeft"></template>
          </HLDetail>
        </template>
      </div>

      <Spin fix v-if="spinShow">
        <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
        <div>操作中，请稍候...</div>
      </Spin>
    </div>
  </Modal>
</template>
<script>
import HLDetail from '@/views/systemManage/ICHL/HLDetail.vue'
import resultComps from './workBenchSupport/index'
import followUpGaugingResult from '@/views/systemManage/followUp/followUpGaugingResult.vue'
import callbackResult from '@/views/systemManage/callback/callbackResult.vue'
export default {
  name: 'workBench',
  components: {
    HLDetail, followUpGaugingResult, callbackResult
  },
  props: {
    show: {
      required: true,
      default: false,
    },
    opts: {
      required: true,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      allPanelComps: resultComps,
      currentWorkMode: '',
      currentLedgerId: null,

      statusCode: null,

      spinShow: false,
      showPanel: false,
      // 当前选择的通话记录
      clickRow: null,

      currentCallRecord: null,
      currentUser: null,
      conversationInfos: [],
      keywords: [],

      timerMessage: null,
      loadingPortrait: false,
      currentPhone: null,

      type: '',
      callPhoneData: null
    }
  },
  computed: {
    baseURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.HL || process.env.VUE_APP_API_ROOT
    },
  },
  watch: {
    // 'status': {
    //   deep: true,
    //   handler: function (val) {
    //     switch (this.activeConfig.serviceCode) {
    //       case 'aliyun':
    //         if (val) {
    //           try {
    //             if (window.workbench) {

    //               window.workbench.register()
    //             } else {

    //             }

    //           } catch (e) {
    //             console.log('register error', e)
    //           }

    //         } else {
    //           try {
    //             window.workbench.logOut()
    //           } catch (e) {
    //             console.log('logOut error', e)
    //           }
    //         }
    //         break
    //     }
    //   }
    // },
    'show': {
      deep: true,
      handler: function (val) {
        this.showPanel = val
        this.$refs.workbenchToolContainer.handlePanel(val)
      }
      // 'show': {
      //   deep: true,
      //   handler: function (val) {
      //     this.showPanel = val
      //     switch (this.activeConfig.serviceCode) {
      //       case 'aliyun':
      //         if (window.workbench) {
      //           window.workbench.changeUIConfig({ mainContentVisible: val })
      //         } else if (this.showPanel) {

      //           this.iniAli()
      //         }
      //         break
      //     }
      //   }
      // }
    },
  },
  methods: {
    changePanel: function (val) {
      this.$emit('changeVisible', val)
    },
    changeStatus: function (val) {
      this.$emit('changeHLFPStatus', val)
    },
    logIn: function () {
      this.$refs.workbenchToolContainer.logIn()
    },
    logOut: function () {
      this.$refs.workbenchToolContainer.logOut()
    },
    cancelLedger: function () {
      this.cancelPanel()
    },
    cancelPanel: function () {
      this.clickRow = null
      this.currentCallRecord = null
      this.currentLedgerId = null
      this.statusCode = null
      this.type = null
      this.callPhoneData = null
      if (this.timerMessage) clearInterval(this.timerMessage)
      this.$emit('changeVisible', false)
    },
    signLog: function (data) {
      let that = this
      this.$axios.post(that.$apis.HLConfigApi.base.signLog, data, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          console.log('push signLog success')
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("提交操作信息失败！")
      })
    },
    onRegister: function (info) {
      this.currentUser = info
    },
    onCallComing: function (callDetail) {
      let that = this
      if (!that.showPanel) {
        that.$Notice.warning({
          title: '您有新的电话待接入',
          name: callDetail.jobId,
          render: h => {
            return h('h5', [
              h('span', '来电号码' + callDetail.caller),
              h('a', {
                attrs: {
                  src: 'javascript: void(0)'
                },
                on: {
                  'click': function () {
                    that.$emit('changeVisible', true)
                    that.$Notice.close(callDetail.jobId)
                  }
                }
              }, ' 前往工作台处理')
            ])
          },
          duration: 29
        })
      }
    },
    /**
   * 推送话务记录
   */
    pushCallRecord: function (data) {
      let that = this
      if (this.type) data.category = this.type
      if (this.callPhoneData && Object.keys(this.callPhoneData).length > 0) data.otherParams = this.callPhoneData
      this.$axios.post(that.$apis.HLConfigApi.callRecord.pushCallRecord, data, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          console.log('pushCallRecord success')
          that.currentCallRecord = res.result || {}
          // 此处不显示台账信息 知道接通之后显示
          // this.currentLedgerId = that.currentCallRecord.ledgerId
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('pushCallRecord err', err)
        that.$Message.error("提交话务信息失败！")
      })
    },
    /**
     * 获取话务记录
     */
    loadCallRecord: function (appId, serialNum) {
      let that = this
      that.currentCallRecord = null
      let params = new this.$URLSearchParams()
      params.append("appId", appId)
      params.append("serialNum", serialNum)
      that.$axios.post(that.$apis.HLConfigApi.callRecord.loadCallRecord, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentCallRecord = res.result || {}
          if (that.currentCallRecord.ledgerId) that.currentLedgerId = that.currentCallRecord.ledgerId
        } else {
          that.$Message.error({
            content: res.message || '获取话务记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '获取话务记录失败！',
          duration: 3
        })
      })
    },

    /**
     * 更新话务记录 
  * 通话建立的时候 callRecordStatus=establish
  * 通话结束的时候 callRecordStatus=release
     */
    updateCallRecord: function (appId, serialNum, callRecordStatus) {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("appId", appId)
      params.append("serialNum", serialNum)
      params.append("callRecordStatus", callRecordStatus)
      that.$axios.post(that.$apis.HLConfigApi.callRecord.updateCallRecord, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentCallRecord = res.result || {}
          if (that.currentCallRecord.ledgerId) {
            that.currentLedgerId = that.currentCallRecord.ledgerId
            console.log('updateCallRecord', that.currentLedgerId)
            if (that.$refs.workbenchDetail && callRecordStatus == 'release') that.$refs.workbenchDetail.reloadData()
          }
          // that.$emit('change', that.currentCallRecord.ledgerId)

          //5秒执行一次获取接口
          // if (that.timerMessage) clearInterval(that.timerMessage)
          // that.timerMessage = setInterval(() => {
          //   if (that.$refs.workbenchDetail) that.$refs.workbenchDetail.callConversationInfo()
          // }, 5000)
        } else {
          that.$Message.error({
            content: res.message || '获取话务记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '获取话务记录失败！',
          duration: 3
        })
      })
    },
    onCallRelease: function (data) {
      console.log('onCallRelease', data)
      let that = this

      let params = new this.$URLSearchParams()
      params.append("appId", data.appId)
      params.append("serialNum", data.serialNum)
      if (data.droper) params.append("droper", data.droper)
      that.$axios.post(that.$apis.HLConfigApi.callRecord.onCallRelease, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentCallRecord = res.result || {}
          if (that.currentCallRecord.ledgerId) {
            that.currentLedgerId = that.currentCallRecord.ledgerId
            console.log('updateCallRecord', that.currentLedgerId)
            // if (that.$refs.workbenchDetail && callRecordStatus == 'release') that.$refs.workbenchDetail.reloadData()
          }
          // that.$emit('change', that.currentCallRecord.ledgerId)

          //5秒执行一次获取接口
          // if (that.timerMessage) clearInterval(that.timerMessage)
          // that.timerMessage = setInterval(() => {
          //   if (that.$refs.workbenchDetail) that.$refs.workbenchDetail.callConversationInfo()
          // }, 5000)
        } else {
          that.$Message.error({
            content: res.message || '获取话务记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '获取话务记录失败！',
          duration: 3
        })
      })
    },
    updateSoundRecording: function (data) {
      let that = this
      let params = new this.$URLSearchParams()
      Object.keys(data).forEach(key => {
        params.append(key, data[key])
      })
      that.$axios.post(that.$apis.HLConfigApi.callRecord.updateSoundRecording, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (!res.success) {
          that.$Message.error({
            content: res.message || '提交录音失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '提交录音失败！',
          duration: 3
        })
      })
    },
    /**
     * 挂断电话
     */
    hangUpRecord: function (type) {
      let that = this
      if (this.currentCallRecord?.appId && this.currentCallRecord?.serialNum) {
        let params = new this.$URLSearchParams()
        params.append("appId", this.currentCallRecord.appId)
        params.append("serialNum", this.currentCallRecord.serialNum)
        params.append("hangUpType", type)
        that.$axios.post(that.$apis.HLConfigApi.callRecord.hangUpRecord, params, {
          baseURL: this.baseURL
        }).then(res => {
          if (res.success) {
            that.currentCallRecord = res.result || {}
            if (that.currentCallRecord.ledgerId) that.currentLedgerId = that.currentCallRecord.ledgerId
            if (that.$refs.workbenchDetail) that.$refs.workbenchDetail.reloadData()
            // that.$emit('change', that.currentCallRecord.ledgerId)
            // that.$refs.workbenchDetail.show()
          } else {
            that.$Message.error({
              content: res.message || '推送挂断失败！',
              duration: 3
            })
          }
        }).catch(function (err) {
          console.log('that error', err)
          that.$Message.error({
            content: '推送挂断失败！',
            duration: 3
          })
        }).finally(() => {
          if (that.timerMessage) clearInterval(that.timerMessage)
          that.timerMessage = null
        })
      }
    },
    changeRecordStatus: function (code) {
      this.statusCode = code
    },
    callPhone: function (params) {
      console.log('workBench callPhone params', params)
      this.type = params.category
      this.callPhoneData = params
      // if (process.env.NODE_ENV == 'production') {
      this.$refs.workbenchToolContainer.callPhone(params)
      // }
    }
  },
  destroyed () {
    console.log('workbench beforeDestroy')
    if (this.timerMessage) clearInterval(this.timerMessage)
    this.$emit('changeVisible', false)
    // window.workbench.reRender()
  }
}
</script>

<style lang="less" scoped>
.followUpContainer {
  height: 100%;
  overflow: hidden;
  position: relative;
}

.callbackContainer {
  height: 100%;
  overflow-y: auto;
  position: relative;
}
</style>
